import Image01 from "../Images/blogImages/BlogImage01.avif";
import Image02 from "../Images/blogImages/BlogImage02.avif";
import Image03 from "../Images/blogImages/BlogImage03.avif";

const BlogData = [
    {
        blogid: "1",
        blogName: "Rg Banquit Hall",
        blogImage: Image01,
        blogtitle: "The Coolest Live Activity Stations for 2025 Weddings!",
        blogshortDes: "That million dollar question  Where should I shop my bridal outfit from? After all everyone is bored of the same old stores which all have the same collection so we asked our Real Brides to",
        blogDate:"26 Jul, 2017",
    },
    {
        blogid: "1",
        blogName: "Rg Banquit Hall",
        blogImage: Image02,
        blogtitle: "Here Is What 70K Can Buy You In The Mumbai Lehenga Scene!",
        blogshortDes: "Calling out to all brides-to-be in Mumbai! Yes! There are some fabulous big time designers in Mumbai of course, but we love some of the work the mid-level designers do too! So if you are scouting for",
        blogDate:"20 Aug, 2018",
    },
    {
        blogid: "1",
        blogName: "Rg Banquit Hall",
        blogImage: Image03,
        blogtitle: "The Coolest Live Activity Stations for 2025 Weddings!",
        blogshortDes: "The Best Bridal Exhibitions In Mumbai In 2023 That You Cannot Miss!",
        blogDate:"03 Feb, 2023",
    },
];

export default BlogData;